export const roles = ["STAFF"];

export const modules = [
  {
    name: "Inventory",
    children: [
      { label: "Item Master", value: "itemmaster" },
      { label: "Category Management", value: "categorymanagement" },
      { label: "Unit Management", value: "unitmanagement" },
      { label: "Supplier Management", value: "suppliermanagement" },
      { label: "Customer Management", value: "customermanagement" },
      { label: "Opening Stock", value: "openingstock" },
      { label: "Stock In", value: "stockin" },
      { label: "Stock Out", value: "stockout" },
      { label: "Stock Adjustment", value: "stockadjustment" },
      { label: "Stock Verification", value: "stockverification" },
      { label: "Stock Ledger", value: "stockledger" },
      { label: "Stock Reports", value: "stockreports" },
      { lable: "Stock Return", value: "stockreturn" },
      { lable: "Current Stock", value: "currentstock" }
    ],
  },
  {
    name: "Cheque Management",
    children: [
      { label: "Bank Details", value: "bankdetails" },
      { label: "Cheque Entry", value: "chequeentry" },
    ],
  },

  {
    name: "Reports",
    children: [
      { label: "Stock Reports", value: "bankdetails" },
      { label: "Cheque Report", value: "chequereport" },
    ],
  },

  {
    name: "Sales",
    children: [
      { label: "Expense", value: "expense" },
      { label: "Invoice", value: "invoice" },
      { label: "Quotation", value: "quotation" },
    ],
  },

  {
    name:"Administration",
    children:[
      { label: "Technician", value: "technician" },
    ]
  }
];

export const permissionList = [
  { label: "View", value: "GET" },
  { label: "Create", value: "POST" },
  { label: "Update", value: "PUT" },
  { label: "Delete", value: "DELETE" },
];